module.exports = __webpack_public_path__ + "static/media/estate-clarity-create-profile-userflow-new.86fe9390.jpg";